const JsForm = {
  init () {

    // Newsletter Signup form for mailchimp, we need to be able to switch the subscriber list with a drop down.
    if ( $('.mailchimp-form-wrapper').length ) {

      // Update subscription list when select is changed
      $('.mce-LANG-list').on('change', function() {
        // console.log(this.value);
        let gdpr = "";

        let targetList = this.value;

        // Get the current action assignment
        let initialAction = $('#mc-embedded-subscribe-form').attr('action');
        // console.log(initialAction);

        // Remove current list ID
        let strippedAction = initialAction.substring(0, initialAction.indexOf('id='));
        // console.log(strippedAction);

        // Add new list ID to action
        let updatedAction = strippedAction + 'id=' + this.value;
        // console.log(updatedAction);

        // Update action with new updated action
        $('#mc-embedded-subscribe-form').attr('action', updatedAction);


        if ( this.value == "2f78647478" ) {
          gdpr = "en"
        } else {
          gdpr = "ga"
        }

        if ( gdpr == "en" ) {
          $('.gdpr-email-checkbox').attr('id', 'gdpr_32345');
          $('.gdpr-email-checkbox').attr('name', 'gdpr[32345]');
          // id = gdpr_32345
          // name = gdpr[32345]
        } else {
          $('.gdpr-email-checkbox').attr('id', 'gdpr_32357');
          $('.gdpr-email-checkbox').attr('name', 'gdpr[32357]');
          // id = gdpr_32345
          // name = gdpr[32345]
        }
      });
    }
  }
};

export default JsForm;



// WEBPACK FOOTER //
// ./src/components/01-elements/form/form.js